import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    categoryOption: ''
  },

  getters: {
    categoryOption(state) {
      return state.categoryOption
    }
  },

  mutations: {
    categoryOption(state, params) {
      state.categoryOption = params
    }
  },

  actions: {
    /**
     * カテゴリ設定取得
     */
    getCategoryOptions({ commit }, payload) {
      return api.get('/api/v2/setting/category/option', {})
        .then((res) => {
          commit('categoryOption', res.data.options)
        })
    },

    /**
     * カテゴリ設定更新
     */
    updateCategorySetting({ commit }, payload) {
      return api.put('/api/v2/setting/category/update', {
        datas: payload.datas
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/setting.js